import { Button, Input, Message, useToaster } from 'rsuite';
import React from 'react';

import * as usersApi from '../../api/users';
import { FormField, FormGrid, FormModal } from '../../common/FormModal';
import { useFormErrors } from '../../common/useFormErrors';

type Props = {
  open: boolean;
  setOpen: (newValue: boolean) => void;
  callback: () => void;
};

export default function CreateUserModal({ open, setOpen, callback }: Props) {
  const toaster = useToaster();
  const { errorSummary, setApiError, clearErrors } = useFormErrors({
    fallbackMessage: 'Не вдалося створити користувача. Спробуйте пізніше',
    resetOn: [open],
  });
  const [userEmail, setUserEmail] = React.useState<string>('');
  const [userPassword, setUserPassword] = React.useState<string>('');

  return (
    <FormModal
      open={open}
      onClose={() => setOpen(false)}
      title="Створити користувача"
      errorSummary={errorSummary}
      footer={
        <>
          <Button
            onClick={async () => {
              clearErrors();
              try {
                await usersApi.create(userEmail, userPassword);
                setOpen(false);
                callback();
              } catch (err: any) {
                console.error(err);
                const errorMessage = setApiError(err)[0];
                toaster.push(
                  <Message type="error" showIcon closable>
                    {errorMessage}
                  </Message>,
                  {
                    placement: 'topEnd',
                    duration: 1500,
                  }
                );
              }
            }}
            appearance="primary"
          >
            Створити
          </Button>
          <Button onClick={() => setOpen(false)} appearance="subtle">
            Скасувати
          </Button>
        </>
      }
    >
      <FormGrid>
        <FormField label="Пошта" id="create-user-email" required>
          <Input
            value={userEmail || ''}
            placeholder="Пошта"
            type="email"
            onChange={setUserEmail}
          />
        </FormField>
        <FormField label="Пароль" id="create-user-password" required>
          <Input
            value={userPassword || ''}
            placeholder="Пароль"
            type="password"
            onChange={setUserPassword}
          />
        </FormField>
      </FormGrid>
    </FormModal>
  );
}
